import React from 'react';
import { Card } from '../ui/card';
import { Button } from '../ui/button';
import { services } from '../../mockData';

const ServicesSection = ({ scrollToBooking }) => {
  return (
    <section id="services" className="section-gray">
      <div className="section-container">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="heading-lg mb-6">Our Services</h2>
          <p className="body-lg text-[var(--text-muted)]">
            Expert coaching tailored to your specific goals, from selective school entrance exams to IELTS and VCE excellence.
          </p>
        </div>
        <div className="grid-2">
          {services.map((service) => (
            <Card key={service.id} className="premium-card">
              <img
                src={service.image}
                alt={service.title}
                className="w-full h-48 object-cover rounded-lg mb-6"
              />
              <h3 className="heading-md mb-4">{service.title}</h3>
              <p className="body-md text-[var(--text-muted)] mb-6">{service.description}</p>
              <ul className="space-y-3 mb-6">
                {service.benefits.map((benefit) => (
                  <li key={benefit} className="flex items-start gap-3">
                    <div className="w-5 h-5 rounded-full flex items-center justify-center flex-shrink-0 mt-0.5" style={{ background: 'var(--accent-sky)' }}>
                      <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
                      </svg>
                    </div>
                    <span className="body-md">{benefit}</span>
                  </li>
                ))}
              </ul>
              <Button onClick={scrollToBooking} className="btn-primary w-full">
                Get Started
              </Button>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
